import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { StoreProvider } from "@/context/StoreContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import ProductDetailPage from "@/pages/ProductDetailPage";
import CaraPesan from "@/pages/CaraPesan";
import Kontak from "@/pages/Kontak";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import ProductsManager from "@/pages/admin/ProductsManager";
import DevicesManager from "@/pages/admin/DevicesManager";
import CategoriesManager from "@/pages/admin/CategoriesManager";
import SettingsManager from "@/pages/admin/SettingsManager";
import UsersManager from "@/pages/admin/UsersManager";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === undefined)
    return <div className="flex h-screen items-center justify-center text-muted-foreground">Memuat...</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function PermRoute({ perm, children }) {
  const { user } = useAuth();
  if (user === undefined)
    return <div className="flex h-screen items-center justify-center text-muted-foreground">Memuat...</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  const ok = user.role === "owner" || perm === "dashboard" || (perm !== "users" && (user.permissions || []).includes(perm));
  if (!ok) return <Navigate to="/admin" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <StoreProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/katalog" element={<Catalog />} />
                <Route path="/produk/:slug" element={<ProductDetailPage />} />
                <Route path="/cara-pesan" element={<CaraPesan />} />
                <Route path="/kontak" element={<Kontak />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Dashboard />} />
                <Route path="produk" element={<PermRoute perm="products"><ProductsManager /></PermRoute>} />
                <Route path="perangkat" element={<PermRoute perm="devices"><DevicesManager /></PermRoute>} />
                <Route path="kategori" element={<PermRoute perm="categories"><CategoriesManager /></PermRoute>} />
                <Route path="pengaturan" element={<PermRoute perm="settings"><SettingsManager /></PermRoute>} />
                <Route path="users" element={<PermRoute perm="users"><UsersManager /></PermRoute>} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors offset="80px" />
        </AuthProvider>
      </StoreProvider>
    </div>
  );
}

export default App;
